import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const DiscordSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      width="33"
      height="33"
      viewBox="0 -6 12 28"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        fill-rule="evenodd"
        d="m5.49837 6.30005v-.62286c-.21339-.02851-.43034-.04633-.6544-.04633-2.67094-.0035-4.84397 2.17132-4.84397 4.84804 0 1.641.817998 3.0933 2.06989 3.9725-.80733-.865-1.301684-2.029-1.301684-3.3033 0-2.63759 2.112564-4.78753 4.730164-4.84805z"
      />
      <Path
        fill={color}
        fill-rule="evenodd"
        d="m5.61279 13.3624c1.19144 0 2.16591-.9504 2.20861-2.1321l.00357-10.561111h1.92761c-.03914-.217132-.06046-.441379-.06046-.669189h-2.63183l-.00356 10.5611c-.04265 1.1817-1.01718 2.1321-2.20859 2.1321-.36987 0-.71841-.0925-1.02783-.2563.39833.5589 1.05273.9255 1.79248.9255z"
      />
      <Path
        fill={color}
        fill-rule="evenodd"
        d="m13.3546 4.25402v-.58728c-.7362 0-1.4191-.21715-1.9952-.59447.5121.58734 1.2056 1.0145 1.9952 1.18175z"
      />
      <Path
        fill={color}
        fill-rule="evenodd"
        d="m9.69245 10.4799v-5.35706c1.03145.7404 2.29755 1.1782 3.66325 1.1782v-2.04671c-.7896-.16726-1.4831-.59442-1.9952-1.18176-.8252-.53745-1.41906-1.39886-1.60759-2.402648h-1.92761l-.00357 10.561078c-.04264 1.1817-1.01717 2.1321-2.20856 2.1321-.73978 0-1.39062-.3666-1.79606-.9219-.70419-.3737-1.18787-1.1105-1.18787-1.9613 0-1.22088.99226-2.214 2.21215-2.214.22761 0 .44812.03914.6544.10322v-2.06452c-2.6176.05696-4.730165 2.20689-4.730165 4.8445 0 1.2743.494355 2.4347 1.301685 3.3032.78599.5518 1.74625.8792 2.77763.8792 2.67096 0 4.84751-2.1784 4.84751-4.8516z"
      />
    </Svg>
  )
}

export default DiscordSvg
